import React, { useRef } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import url from "../config/Config";
import { useEffect } from "react";
import { useState } from "react";
import { getImage } from "../../helpers";
import { formatHumansBs } from "../../helpers/formatHuman";
import ModalProductoDetalle from "../productos/ModalProductoDetalle";
import { agregarCarrito } from "../../helpers/carrito";
import ProductoItemSlide from "./ProductoItemSlide";

const buttonStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    padding: "12px 14px",
    backgroundColor: "#fff",
    border: "2px solid #6b306e",
    fontSize: "20px",
    color: "#000",
    cursor: "pointer",
    borderRadius: "0.375rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "none",
};

const ProductosMain = ({
    api,
    titulo,
    classNameTitulo = "",
    classNameVermas = "",
}) => {
    const slideRef = useRef(null);
    const [productMain, setProductMain] = useState([]);
    const [isMobile, setIsMobile] = useState(url.isMobileDevice());
    const [modalProductoDetalle, setModalProductoDetalle] = useState(false);

    const [dataProductDetail, setDataProductDetail] = useState({
        images: [],
        caracteristicas: [],
        especificaciones: [],
    });

    const [product, setProduct] = useState({});

  

    const listaDetalleProducto = (idProducto) => {
        setDataProductDetail([]);
        let datos = {
            accion: "detalles",
            llave: url.llavedefault,
            idproducto: idProducto,
        };
        fetch(url.service + "producto", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson[0].imagenes) {
                    setDataProductDetail((prev) => ({
                        ...prev,
                        images: responseJson[0].imagenes,
                    }));
                }
                if (responseJson[0].caracteristicas) {
                    setDataProductDetail((prev) => ({
                        ...prev,
                        caracteristicas: responseJson[0].caracteristicas,
                    }));
                }
                if (responseJson[0].esptecnicas) {
                    setDataProductDetail((prev) => ({
                        ...prev,
                        especificaciones: responseJson[0].esptecnicas,
                    }));
                }
                setModalProductoDetalle(!modalProductoDetalle);
            });
    };

    useEffect(() => {
        obtenerDatos();
    }, []);

    const properties = {
        prevArrow: isMobile ? null : (
            <button style={{ ...buttonStyle, left: "-70px" }}>
                <i className="fas fa-chevron-left" />
            </button>
        ),
        nextArrow: isMobile ? null : (
            <button style={{ ...buttonStyle, right: "-70px" }}>
                <i className="fas fa-chevron-right" />
            </button>
        ),
    };

    const obtenerDatos = () => {
        let datos = {
            accion: api,
            llave: url.llavedefault,
        };
        fetch(url.service + "producto", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                setProductMain(responseJson);
            });
    };

    return (
        <>
            <section className="max-w-7xl mx-auto mb-8 p-2 lg:p-0">
                <div className="flex justify-center p-4">
                    <h2
                        className={`${
                            classNameTitulo
                                ? classNameTitulo
                                : "text-tertiary-personalize border-b-secondary-personalize "
                        } border-b-4  font-bold text-2xl lg:text-4xl`}
                    >
                        {titulo}
                    </h2>
                </div>

                <div className="relative">
                    <Slide
                        ref={slideRef}
                        arrows={!isMobile}
                        indicators={isMobile}
                        {...properties}
                    >
                        {productMain.map((_, idx) => {
                            const cantidadPorSlide = isMobile ? 2 : 4;

                            const grupo = productMain.slice(
                                idx,
                                idx + cantidadPorSlide
                            );

                            return (
                                <div
                                    key={idx}
                                    className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-0 lg:gap-4"
                                >
                                    {grupo.map((item, index) => (
                                        <ProductoItemSlide
                                            key={index}
                                            item={item}
                                            listaDetalleProducto={ listaDetalleProducto }
                                            setProduct={ setProduct }
                                        />
                                    ))}
                                </div>
                            );
                        })}
                    </Slide>
                    <div className="flex justify-end mt-2">
                        <a
                            href={
                                "/Mas" +
                                "?e=".concat(localStorage.getItem("empresa"))
                            }
                            className={`${
                                classNameVermas
                                    ? classNameVermas
                                    : "bg-tertiary-personalize"
                            } text-center my-2  px-3 py-1 font-bold rounded-full hover:no-underline `}
                        >
                            Ver Más
                        </a>
                    </div>
                </div>
            </section>
            <ModalProductoDetalle
                modalProductDetails={modalProductoDetalle}
                setModalProductDetail={setModalProductoDetalle}
                dataProductDetail={dataProductDetail}
                product={product}
            />
        </>
    );
};

export default ProductosMain;
